import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import SettingsPage from './settingsPage'
import TemperatureReportPage from './temperatureReportPage'
import TemparatureReportPageV2 from './temparatureReportPageV2'
import TemperatureHistory from './temperatureHistory'

export const subPageOptions = {
  tempHistory: 'temp-history',
  tempReport: 'temp-report',
  tempLogs: 'temp-logs',
  settings: 'settings'
}

export const ClimateSystemPage = () => {
  const location = useLocation()

  const [subPage, setSubPage] = useState( useLocation().pathname.split('/')[useLocation().pathname.split('/').length - 1] )

  useEffect(() =>{
    setSubPage(location.pathname.split('/')[location.pathname.split('/').length - 1])
  }, [location])

  return (
    <>
      {subPage === subPageOptions.tempReport && <TemperatureReportPage />}
      {subPage === subPageOptions.tempLogs && <TemparatureReportPageV2 />}
      {subPage === subPageOptions.settings && <SettingsPage />}
      {subPage === subPageOptions.tempHistory && <TemperatureHistory />}
    </>
  )
}
